var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.333 34.083q-4.75 0-9.479-2.375-4.729-2.375-8.5-6.146-3.771-3.77-6.125-8.479-2.354-4.708-2.354-9.458 0-.75.521-1.271.521-.521 1.271-.521h5q.625 0 1.104.417.479.417.604 1.083l1 4.625q.083.584-.042 1.105-.125.52-.5.854l-3.875 3.791q2.25 3.792 5.104 6.625 2.855 2.834 6.563 4.875l3.75-3.875q.417-.416.937-.604.521-.187 1.105-.062l4.208.916q.667.125 1.083.625.417.5.417 1.209v4.833q0 .792-.521 1.312-.521.521-1.271.521ZM9.917 15.792l3.291-3.167q.042-.083.063-.187.021-.105.021-.188l-.834-4.083q-.041-.125-.125-.188-.083-.062-.208-.062H8.208q-.125 0-.187.062-.063.063-.063.188.042 1.666.521 3.562.479 1.896 1.438 4.063Zm14.666 14.416q1.667.792 3.625 1.25 1.959.459 3.625.5.084 0 .146-.062.063-.063.063-.146v-3.917q0-.125-.063-.208-.062-.083-.187-.083l-3.709-.75q-.083-.042-.145-.021-.063.021-.146.104ZM9.917 15.792Zm14.666 14.416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall2);
export default __webpack_public_path__ + "static/media/icon-call2.9c7fb7397a27ede813e0e5df3dc00584.svg";
export { ForwardRef as ReactComponent };